export enum FieldType {
    number = 1,
    boolean = 2,
    string = 0
}